export default function (image: ImageProps, defaultOpacity = 0.5): string {
  if (!image.opacity && !image.url) {
    return '';
  }

  const gradient = gradientOpacity(image.opacity ?? defaultOpacity);

  return image.url ? `${gradient}, url('${image.url}')` : gradient;
}

export const gradientOpacity = (opacity: number) => {
  return `-webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, ${opacity})), to(rgba(0, 0, 0, ${opacity})))`;
};

interface ImageProps {
  url?: string;
  opacity?: number;
}
